import axios from '../../apis/apicidtech';
import { types } from '../../types/types';
import { getToken } from '../../utils/tokencidtechapi';
import { dispatchpending, dispatchresponse, dispatchresponseerror } from '../utils/dispatches';

export const pesquisa = (filtro = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.get('credenciamento/formularios/campos/pesquisa',{
                headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                },                
                params: { 
                    ...filtro
                }
            });

            dispatchresponse(dispatch, response.data,types.FORMS.PESQUISA_CAMPOS);
            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const pesquisaCategorias = (filtro = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.get('credenciamento/formularios/pesquisa/categorias',{
                headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                },                
                params: { 
                    ...filtro
                }
            });

            dispatchresponse(dispatch, response.data,types.FORMS.PESQUISA_CATEGORIAS);
            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const novoatualiza = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.put('credenciamento/formularios/campos/novoatualiza',
            {
                ...dados
            },
            {
                headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                }                
            });

            dispatchresponse(dispatch, response.data,types.FORMS.NOVOATUALIZA);
            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const novoatualizaperguntas = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.put('credenciamento/formularios/campos/novoatualizaperguntas',
            {
                ...dados
            },
            {
                headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                }                
            });

            dispatchresponse(dispatch, response.data,types.FORMS.NOVOATUALIZA);
            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const novacategoriaForm = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.put('credenciamento/formularios/nova/categoria',
            {
                ...dados
            },
            {
                headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                }                
            });

            dispatchresponse(dispatch, response.data,types.FORMS.NOVACATEGORIA);
            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const removeCategoriaForm = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.put('credenciamento/formularios/deleta/categoria',
            {
                ...dados
            },
            {
                headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                }                
            });

            dispatchresponse(dispatch, response.data,types.FORMS.REMOVECATEGORIA);
            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const pesquisaBaseCategorias = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.get('credenciamento/formularios/base/pesquisa/categoria',            
            {
                headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                },
                params: {
                    ...dados
                }               
            });

            dispatchresponse(dispatch, response.data,types.FORMS.PESQUISA_BASE_CATEGORIA);
            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}